import type { PanelPart, Project } from '../types';
import { generateCuttingList } from '../geometry/furniture';

const csvCell = (value: string | number) => `"${String(value).replaceAll('"', '""')}"`;

export function createCuttingListCsv(project: Project, parts: PanelPart[] = generateCuttingList(project.furniture)) {
  const headings = ['Project', 'Furniture', 'Part', 'Length', 'Width', 'Thickness', 'Material', 'Quantity', 'Left cut height', 'Right cut height'];
  const rows = parts.map((part) => [project.name, part.furnitureName, part.name, part.length, part.width, part.thickness, project.materials.find((m) => m.id === part.materialId)?.decorCode ?? part.materialId, part.quantity, part.profileTop?.[0] ?? '', part.profileTop?.[1] ?? '']);
  return `\uFEFF${[headings, ...rows].map((row) => row.map(csvCell).join(';')).join('\r\n')}`;
}

export function exportCuttingList(project: Project, parts: PanelPart[] = generateCuttingList(project.furniture)) {
  const csv = createCuttingListCsv(project, parts);
  const url = URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8' }));
  const link = document.createElement('a');
  link.href = url;
  link.download = `${project.name.replace(/[^a-z0-9-_]+/gi, '-')}-cutting-list.csv`;
  link.click();
  URL.revokeObjectURL(url);
}
